"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgStarsAndUfo = function SvgStarsAndUfo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 166 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "stars-and-ufo_svg__h",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 95.79,
    height: 24.024,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars-and-ufo_svg__a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "stars-and-ufo_svg__i",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 66.56,
    height: 20.8,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars-and-ufo_svg__b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "stars-and-ufo_svg__j",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 5.474,
    height: 5.474,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars-and-ufo_svg__c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "stars-and-ufo_svg__k",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 5.474,
    height: 5.474,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars-and-ufo_svg__d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "stars-and-ufo_svg__l",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 5.474,
    height: 5.474,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars-and-ufo_svg__e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "stars-and-ufo_svg__m",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 5.474,
    height: 5.474,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars-and-ufo_svg__f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "stars-and-ufo_svg__n",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 5.474,
    height: 5.474,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars-and-ufo_svg__g"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "stars-and-ufo_svg__c",
    cx: 42.947,
    cy: 51.246,
    r: 2.737
  }), /*#__PURE__*/React.createElement("circle", {
    id: "stars-and-ufo_svg__d",
    cx: 59.947,
    cy: 56.246,
    r: 2.737
  }), /*#__PURE__*/React.createElement("circle", {
    id: "stars-and-ufo_svg__e",
    cx: 98.947,
    cy: 56.246,
    r: 2.737
  }), /*#__PURE__*/React.createElement("circle", {
    id: "stars-and-ufo_svg__f",
    cx: 79.79,
    cy: 57.719,
    r: 2.737
  }), /*#__PURE__*/React.createElement("circle", {
    id: "stars-and-ufo_svg__g",
    cx: 114.632,
    cy: 50.983,
    r: 2.737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.534 47.223c8.095-1.299 14.491-3.516 17.844-6.223 8.304 2.55 13.412 6.02 13.412 9.842 0 7.833-21.444 14.182-47.895 14.182C53.443 65.024 32 58.674 32 50.842 32 47.02 37.107 43.55 45.412 41c3.464 2.797 10.178 5.072 18.658 6.35",
    id: "stars-and-ufo_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 38.8C54.016 24.933 65.18 18 80.493 18s26.335 6.933 33.067 20.8",
    id: "stars-and-ufo_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.105 65.005c25.29-.385 45.395-6.579 45.395-14.163 0-3.81-5.073-7.268-13.328-9.816l-.902-2.226c-6.36-13.1-16.549-20.012-30.567-20.736a48.537 48.537 0 0 1 2.5-.064c15.313 0 26.335 6.933 33.068 20.8l.902 2.226c8.254 2.548 13.327 6.007 13.327 9.816 0 7.833-21.443 14.182-47.895 14.182-.838 0-1.672-.006-2.5-.019z",
    fill: "#E1F3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17181A",
    cx: 68,
    cy: 38,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17181A",
    cx: 92,
    cy: 38,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 50c7.113-2.667 14.113-2.667 21 0",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10 16-5.878 3.09 1.123-6.545L.489 7.91l6.572-.955L10 1l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545zm142 5.559L143.347 26 145 16.593l-7-6.662 9.674-1.372L152 0l4.326 8.559L166 9.93l-7 6.662L160.653 26zM127.5 95.95 123.483 98l.767-4.342-3.25-3.074 4.491-.634L127.5 86l2.009 3.95 4.491.634-3.25 3.074.767 4.342z"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    mask: "url(#stars-and-ufo_svg__h)",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: 2,
    xlinkHref: "#stars-and-ufo_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    mask: "url(#stars-and-ufo_svg__i)",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: 2,
    xlinkHref: "#stars-and-ufo_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    mask: "url(#stars-and-ufo_svg__j)",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: 2,
    xlinkHref: "#stars-and-ufo_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    mask: "url(#stars-and-ufo_svg__k)",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: 2,
    xlinkHref: "#stars-and-ufo_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    mask: "url(#stars-and-ufo_svg__l)",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: 2,
    xlinkHref: "#stars-and-ufo_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    mask: "url(#stars-and-ufo_svg__m)",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: 2,
    xlinkHref: "#stars-and-ufo_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    mask: "url(#stars-and-ufo_svg__n)",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: 2,
    xlinkHref: "#stars-and-ufo_svg__g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.998 73 51 91.013M101 73l5.998 18.013",
    stroke: "#C2C5CC",
    strokeDasharray: 2
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgStarsAndUfo);
var _default = exports["default"] = Memo;